module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/search_result_page/prefecture-503d84277bb5ce3dff31167c4dc0a16b.png";